<template>
  <div class="checklist__heading" :class="toolsVisible">
    <div
      v-if="!isEditing"
      class="checklist__heading-text"
      :class="isTemplatePage && 'compact'"
      @mouseover="!isDetailPage && showTools()"
      @mouseleave="!isDetailPage && hideTools()"
    >
      <!-- title -->
      <AppHeading @click="titleClicked" tag="h4" :text="checklistTitle" />
      <!-- tools box -->
      <ChecklistsToolsBox
        v-allowed:employee
        :isActive="checklist.is_active"
        :compact="isTemplatePage"
        :show-tools="toolsVisible && !isEditing"
        @actionRequested="checkAction"
      />
    </div>
    <!-- edit box -->
    <EditBox
      :value="checklistTitle"
      v-if="isEditing"
      @edition-done="prepareValues"
      @close-box="closeEditBox"
    />
  </div>
</template>

<script>
// Utils
import ChecklistsMixin from '../mixins'
// Components
import AppHeading from 'Ui/AppHeading'

export default {
  name: 'ChecklistsChecklistHeading',

  components: {
    AppHeading,
  },

  props: {
    checklist: {
      type: Object,
      required: true,
    },
  },

  mixins: [ChecklistsMixin],

  data() {
    return {
      toolsVisible: false,
    }
  },

  methods: {
    showTools() {
      this.toolsVisible = true
    },

    hideTools() {
      this.toolsVisible = false
    },

    titleClicked() {
      this.$emit('title-clicked')
    },

    checkAction(action) {
      if (action === 'status') this.changeStatus()
      if (action === 'edit') this.openEditBox(), this.hideTools()
      if (action === 'delete') this.deleteChecklist()
    },

    prepareValues(value) {
      const newData = {
        title: value,
      }
      // preparing requested values for API call
      const checklistInfo = this.getChecklistData({
        checklistId: this.checklist.id,
        newData: newData,
      })
      this.saveChanges(checklistInfo)
    },

    changeStatus() {
      const newData = { is_active: !this.checklist.is_active }
      // preparing requested values for API call
      const checklistInfo = this.getChecklistData({
        checklistId: this.checklist.id,
        newData: newData,
      })
      this.saveChanges(checklistInfo)
    },

    deleteChecklist() {
      const { actionType, cardId, checklistId } = this.getChecklistData({
        checklistId: this.checklist.id,
      })
      this.$store.dispatch('checklists/deleteChecklist', { actionType, cardId, checklistId })
    },
  },

  computed: {
    checklistTitle() {
      return this.checklist.title
    },
  },

  watch: {
    changesSaved(saved) {
      saved && this.closeEditBox()
    },
  },
}
</script>

<style scoped>
.checklist__heading {
  position: relative;
}

.template .checklist__heading {
  margin-right: 20px;
}

.checklist__heading-text {
  position: relative;
  padding: 8px 0 8px 8px;
  margin: -3px 0 -3px -5px;
}

.checklist__heading-text .app-heading {
  display: inline-block;
  width: auto;
  max-width: calc(100% - 105px);
  position: relative;
  z-index: 1;
  cursor: pointer;
}

.checklist__heading-text.compact .app-heading {
  max-width: calc(100% - 70px);
}

/* checklist locked */
.locked:not(.template) .checklist__heading-text .app-heading {
  color: var(--c-secondary-500);
}
</style>
